export const FIRST_VISIT =
  typeof window !== "undefined" &&
  !window.sessionStorage.getItem("nt_seen");

export const APP_STORE_URL = "https://apps.apple.com/app/nailtape";
export const TIKTOK_URL = "https://www.tiktok.com/@nailtapeapp";
export const INSTAGRAM_URL = "https://www.instagram.com/nailtape_us";
export const CONTACT_EMAIL = "support@nailtape.us";
export const PRIVACY_URL = "https://nailtape.us/privacy";
export const TERMS_URL = "https://nailtape.us/terms";

export const MANIFESTO = [
  {
    num: "01",
    title: "Everything is where it belongs.",
    body: "Orders, measurements, client details, statuses. What used to live in DMs, notes and memory now lives in one place. That is the whole idea.",
    image: "/images/lifestyle_morning.jpeg",
    caption: "Fig. 02 — The morning",
  },
  {
    num: "02",
    title: "The business stops living in your head.",
    body: "Every order has a record. Every client has a file. Nothing depends on memory at the end of a long day.",
    image: "/images/lifestyle_desk.jpeg",
    caption: "Fig. 03 — The desk",
  },
  {
    num: "03",
    title: "Time returns to the work itself.",
    body: "The filing, the blends, the tiny perfect lines — that is the business. NailTape runs the workflow around it.",
    image: null,
  },
];

export const FEATURES = [
  {
    id: "chekflow-system",
    num: "01",
    term: "The Checkflow System™",
    body: "A reinforcement learning system curated by nailtape™. Order management and client communication, together — Checkflow tracks your activity and emails clients their order status from beginning to end. No more DMs: a cleaner, more professional experience for them, far less to manage for you.",
  },
  {
    id: "digital-nail-sizing",
    num: "02",
    term: "Digital nail sizing",
    body: "Each client's nail sizes, measured and stored precisely. Sizing becomes data, not guesswork.",
  },
  {
    id: "style-library",
    num: "03",
    term: "Style Library™ + Moodbox™",
    body: "The catalogue, documented — every set you've made, browsable and ready to reference.",
  },
  {
    id: "business-analytics",
    num: "04",
    term: "Business analytics",
    body: "Revenue, order volume, best sellers. The numbers behind the business, no spreadsheet required.",
  },
];

export const FAQS = [
  {
    q: "How does the free trial work?",
    a: "Download nailtape™ on the App Store and the monthly plan includes 7 days free. The App Store reminds you before the trial ends — cancel during the trial and you won't be charged.",
  },
  {
    q: "What is the Checkflow System™?",
    a: "The Checkflow System™ is a reinforcement learning system curated by nailtape™. It runs orders and clients together — tracking your activity and emailing clients their status automatically, from the moment they order to delivery. Your clients get a clean, professional experience — and you get your DMs back.",
  },
  {
    q: "Can I cancel my subscription?",
    a: "Any time. Manage or cancel in your App Store subscription settings; access continues through the end of the period you've paid for.",
  },
  {
    q: "Is NailTape on Android?",
    a: "nailtape™ is on iOS today. Android is on the roadmap — the update list hears first.",
  },
  {
    q: "What happens to my data?",
    a: "Your orders, clients and measurements are yours — stored securely, linked to your Apple ID, and deletable from the app if you ever leave.",
  },
  {
    q: "What's your refund policy?",
    a: "Billing runs through Apple, so refunds go through Apple directly. If a charge ever looks wrong, email us — we'll help you through it.",
  },
];
